
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoffice/privacy-policy",
      function () {
        return require("private-next-pages/debtreliefoffice/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoffice/privacy-policy"])
      });
    }
  